module.exports = __webpack_public_path__ + "static/media/typeform-logo.18e1659c.png";